<template>
  <section id="w-canvas-wrap" class="workspace__canvas canvas__wrap"
           v-bind:style="{ minWidth: canvasWidth + 'px', minHeight: canvasHeight + 'px' }">
    <div class="canvas--row canvas--row__top canvas--nav-header">
      <!-- 선택 미션-->
      <span class="canvas--nav-header--title">{{selectedTitle}}</span>
      <!-- 미션 네비게이션-->
      <!--&lt;!&ndash; 미션 리스트 &ndash;&gt;-->
      <!--<ul class="canvas&#45;&#45;nav-header__list" v-bind:class="missionListCheck">-->
      <!--<li v-for="(title, index) in missionList"-->
      <!--v-on:click="selectedMission">${index + 1}. ${title}</li>-->
      <!--</ul>-->
    </div>

    <div id="ws-canvas-wrapper" class="canvas--main">
      <canvas id="canvas" v-bind:width="canvasWidth" v-bind:height="canvasHeight"
              style="border-radius: 10px;"></canvas>
    </div>

    <div class=" canvas--row canvas--row__bottom canvas--controller">
      <div class="canvas--controller__wrap">
        <!-- 한줄 실행 -->
        <button class="canvas--controller__btn canvas--controller--step"
          v-if="!isRunner"
          v-bind:class="checkStepStatus"
          v-on:click="lineRead">
          <span class="btn--thumb"></span> <span class="btn--text">단계</span>
        </button>
        <!-- 실행 -->
        <button class="canvas--controller__btn canvas--controller--start"
                v-bind:class="checkGameStatus"
                v-on:click="toggleGameRunnable">
          <span class="btn--thumb"></span> <span class="btn--text">{{checkBtnText}}</span>
        </button>
        <!-- 속도 변경 -->
        <template v-if="!isRunner">
          <button class="canvas--controller--speed canvas--controller__btn"
            v-bind:class="checkGameSpeed"
            v-on:click="changeGameSpped"></button>
          <span class="canvas--controller--speed-txt">x{{gameSpeed}}</span>
        </template>
      </div>
    </div>
  </section>
</template>

<script>
  let Canvas;
  import BlocklyManager from '../../assets/js/codmos/BlocklyManager';

  export default {
    name: 'canvasTemplate',
    props : ['setup_data', 'course_cat', 'map_cat', 'stage_cat', 'mission_cat', 'studyModalVue', 'type'],
    data() {
      let canvasBGM = '/codmos/static/assets/logicong-study-resources/sound/';

      if (this.course_cat === 'ESOF02') {
        canvasBGM += 'peng';
      } else if (this.course_cat === 'ESOF03') {
        canvasBGM += 'jb';
      } else {
        canvasBGM += 'main';
      }

      canvasBGM += '_bg.mp3';

      return {
        selectedTitle: '',
        isMissionListClosed: true,

        // [#] game 관련
        gameSpeed: 1,
        gameRunnable: true,
        gameStartPoint : null,
        gameRunningPoint : null,
        gameEndPoint : null,
        isCleared : '',

        // [#] canvas 관련
        canvasID : 'canvas',
        canvasGridId : 'grid',
        // canvasResourceSrc : 'https://s3.ap-northeast-2.amazonaws.com/logicong-study-resources/',
        canvasResourceSrc : '/codmos/static/assets/logicong-study-resources/',
        canvasBGM,
        canvasDefaultMute : false,
        canvasDefaultSpeed : 1,
        canvasController : null,
        canvas: null,
        resource: null,
        resourceNeedReloadingAttr: ['size', 'pointX', 'pointY'],
        canvasTypeBG : 'bg',
        canvasWidth: 0,
        canvasHeight: 0,
        canvasStatusEnd: false, // "성공 or 실패"로써 다음 상태값을 해제할 수 있음, 인터프리터가 종료됬는데 "canvasStatusEnd"가 아직 false라는 것은 ???
        canvasStatueStep: false, // 스탭이 진행중인가 ?
        endPhase: false,
        needToToggle: false,

        // [#] modal 관련
        workCount: 0,
        maxWorkCount: 0,

        isLibLoad: false
      }
    },
    computed: {
      /**
       *  @DESC   Game 속도에 따른 텍스트 변경
       */
      checkGameSpeed() {
        return `s-${this.gameSpeed}`;
      },
      /**
       *  @DESC   시작하기 버튼 텍스트 변경
       */
      checkBtnText() {
        let text = '';
        if (this.gameRunnable) {
          this.$emit('canvas_stop');
          text = '시작하기';
        } else {
          this.$emit('canvas_start');
          text = '다시하기';
        }
        return text;
      },
      /**
       *  @DESC   블록 실행중에 따른 아이콘 상태
       */
      checkGameStatus() {
        return this.gameRunnable ? 'wait' : 'run';
      },
      /**
       *  @DESC   블록 실행중에 따른 아이콘 상태
       */
      checkStepStatus() {
        return this.canvasStatueStep === false ? 'wait' : 'run';
      },
      isRunner() {
        return this.type === 'runner';
      }
    },
    methods: {
      /**
       *  @DESC   속도 변경하기
       */
      changeGameSpped() {
        // [#] View 속도변경
        if (this.gameSpeed !== 3) this.gameSpeed += 1;
        else this.gameSpeed = 1;

        // [#] 캔버스 속도변경
        this.canvasController.setSpeed(this.gameSpeed);
        document.cookie = `gameSpeed=${this.gameSpeed}; expires=Thur, 31 Dec 2099 23:59:59 UTC;`
        this.$emit('call_canvas_speed'); // setSpeed;
      },
      /**
       *  @DESC   게임 전체 실행 / 정지
       */
      toggleGameRunnable() {
        // [#] "스탭진행중"이라는 표시 => Run 진행중에 Step 진행할 수 없음
        this.canvasStatueStep = true;

        if (this.gameRunnable) {
          // [#] 코드시작시간
          this.gameRunningPoint = new Date();

          if (this.isRunner) {
            this.canvasController.run(BlocklyManager);
            this.gameRunnable = false;
          } else {
            // [#] interpreter run (시작하기)
            if (BlocklyManager.interpreter.status === 0 /*wait*/) {
              BlocklyManager.initInterpreterByBlock('when_press_start_button');
            }
            BlocklyManager.interpreter.run();
            this.gameRunnable = false;
          }
        } else {
          // [#] interpreter stop (처음상태로)
          this.restartCanvas();
        }
      },
      /**
       *  @DESC   한 줄 실행
       */
      lineRead() {
        // [#] "스탭진행중"이라는 표시 => 콜백이나 재시작에서 풀어줘야합니다.
        this.canvasStatueStep = true;

        if(this.gameRunnable) {

          // [#] 코드시작시간
          this.gameRunningPoint = new Date();

          // [#] interpreter step (단계시작하기)
          if(BlocklyManager.interpreter.status === 0 /*wait*/) {
            BlocklyManager.initInterpreterByBlock('when_press_start_button');
          }
          BlocklyManager.interpreter.step();
          this.gameRunnable = false;
        }
        else {
          BlocklyManager.interpreter.step();
        }
      },
      /**
       *  @DESC   선택 미션 네비게이션
       */
      selectedMission() {
        alert('Selected !!')
      },
      /**
       * [ Function :: createCanvas ]
       *
       * @DES :: 캔버스 객체 생성하는 함수
       * @IP1 :: setupData {json}
       * @O.P :: null
       * @S.E ::
       */
      createCanvas(setupData) {
        if (!this.isLibLoad) this.libLoad();

        const MAP_SIZE = setupData.mapSize;
        const ARR_RESOURCE = setupData.file;
        const ARR_PATH = setupData.path;
        const ARR_OBJECT = setupData.object;
        const ARR_SOLUTION = setupData.solution;
        const ARR_VARIABLE = setupData.variable;

        // [#] speed ui init
        this.gameSpeed = this.canvasDefaultSpeed;

        Canvas.prototype.src = this.canvasResourceSrc;
        Canvas.prototype.bgm = this.canvasBGM;
        Canvas.prototype.mut = this.canvasDefaultMute;

        if (this.isRunner) { // 러너 게임 캔버스 시작

          if (this.canvas === null || typeof this.canvas === 'undefined') {
            this.canvas = new Canvas(this.canvasID, ARR_RESOURCE, (controller, resource) => {
              this.canvasController = controller;
              this.resource = resource;

              this.runnerCanvasSetObject(MAP_SIZE, ARR_RESOURCE, ARR_OBJECT, ARR_SOLUTION, ARR_VARIABLE);

              this.$emit('loading_done');
            });
          } else {
            this.canvas.onCanvasWorldInit = (controller) => {
              this.imageLoad(this.canvasController, ARR_RESOURCE)
                .then(() => {
                  this.canvasController = controller;
                  this.runnerCanvasSetObject(MAP_SIZE, ARR_RESOURCE, ARR_OBJECT, ARR_SOLUTION, ARR_VARIABLE);
                });
            };
            this.canvasController.reloadQuestion();
          }
        } else { // 일반 게임 캔버스 시작
          Canvas.prototype.spd = this.canvasDefaultSpeed;
  
          if (this.canvas === null || typeof this.canvas === 'undefined') {
            this.canvas = new Canvas(this.canvasID, ARR_RESOURCE, (controller, resource) => {
              this.canvasController = controller;
              this.resource = resource;
  
              this.canvasSetObject(MAP_SIZE, ARR_SOLUTION, ARR_PATH, ARR_OBJECT, ARR_VARIABLE)
  
              this.canvas.onCanvasWorldInit = (controller) => {
                this.canvasController = controller;
                this.canvasSetObject(MAP_SIZE, ARR_SOLUTION, ARR_PATH, ARR_OBJECT, ARR_VARIABLE)
              }

              this.$emit('loading_done');
            });
          } else {
            this.canvas.onCanvasWorldInit = (controller) => {
              Object.keys(ARR_RESOURCE).forEach(e => {
                const RES = this.resource[e]
  
                if (typeof RES !== 'undefined') {
                  const NEW_RES = {}
                  for (let key in RES) {
                    NEW_RES[key] = RES[key]
                  }
                  Object.keys(ARR_RESOURCE[e]).forEach(e2 => {
                    if (
                      this.resourceNeedReloadingAttr.indexOf(e2) > -1
                      && NEW_RES[e2] !== ARR_RESOURCE[e][e2]
                    ) {
                      NEW_RES[e2] = ARR_RESOURCE[e][e2]
                    }
                  })
  
                  NEW_RES.result = NEW_RES._result
  
                  this.canvas.res[e] = NEW_RES
                  this.resource[e] = NEW_RES
                }
  
                if (
                  typeof RES === 'undefined'
                  || RES.src !== ARR_RESOURCE[e].src
                ) {
                  ARR_RESOURCE[e].res = e
                  ARR_RESOURCE[e].result = new Image()
                  ARR_RESOURCE[e].result.src = Canvas.prototype.src + ARR_RESOURCE[e].src
  
                  ARR_RESOURCE[e]._result = ARR_RESOURCE[e].result
  
                  this.canvas.res[e] = ARR_RESOURCE[e]
                  this.resource[e] = ARR_RESOURCE[e]
                }
              })
  
              this.canvasController = controller;
              this.canvasSetObject(MAP_SIZE, ARR_SOLUTION, ARR_PATH, ARR_OBJECT, ARR_VARIABLE)
            }
  
            this.canvasController.reloadQuestion();
          }
        }
      },
      imageLoad(controller, ARR_RESOURCE) {
          return Promise.all(Object.keys(ARR_RESOURCE).map(e => new Promise((resolve) => {
            const obj = ARR_RESOURCE[e];

            if (!obj.src) {
              resolve();
            } else {
              const RES = Object.values(this.resource).find(e2 => e2.src === obj.src);

              if (typeof RES !== 'undefined') {
                const NEW_RES = { ...RES };
                Object.keys(obj).forEach((e2) => {
                  if (e2 !== 'src' && NEW_RES[e2] !== obj[e2]) {
                    NEW_RES[e2] = obj[e2];
                  }
                });

                NEW_RES.result = NEW_RES._result;

                this.resource[e] = NEW_RES;
                controller.updateResource(e, NEW_RES);
              }

              if (typeof RES === 'undefined' || RES.src !== obj.src) {
                obj.result = new Image();
                obj.result.crossOrigin = 'anonymous';
                obj.result.onload = () => {
                  obj._result = obj.result;

                  this.resource[e] = obj;
                  controller.updateResource(e, obj);

                  resolve();
                };
                obj.result.src = `${this.canvasDefaultSrc + obj.src}?createjs`;
              } else resolve();
            }
          })));
        },
      canvasSetObject(MAP_SIZE, ARR_SOLUTION, ARR_PATH, ARR_OBJECT, ARR_VARIABLE) {
        // # 01. 배경 등록 (type == "bg")
        for (let key in this.resource) {
          if (this.resource[key].type === this.canvasTypeBG) {
            this.canvasController.setBG(this.resource[key].res);
          }
        }

        // # 02. 그리드
        const CANVAS = document.getElementById("canvas");
        this.canvasMakeGrid(this.canvasController, this.canvasGridId, CANVAS.width, CANVAS.height, MAP_SIZE);

        // # 03. 정답 등록
        if(typeof ARR_SOLUTION !== 'undefined') {
          ARR_SOLUTION.forEach((v) => {
            this.canvasController.addSolution(v);
          })
        }

        // # 04. 패스 등록
        if(typeof ARR_PATH !== 'undefined') {
          ARR_PATH.forEach((v) => {
            this.canvasController.world[this.canvasGridId].addObject(v);
          });
        }

        // # 05. 오브젝트 등록
        if(typeof ARR_OBJECT !== 'undefined') {
          ARR_OBJECT.forEach((v) => {
            this.canvasController.world[this.canvasGridId].addObject(v);
          });
        }

        // # 06. 변수 등록
        if (Array.isArray(ARR_VARIABLE)) {
            this.canvasController.isVariable = !!ARR_VARIABLE.length;
            ARR_VARIABLE.forEach((v) => { this.canvasController.setVariable(v); });
        }

        // # 06. 종료 이벤트 연결
        this.canvasController.onCanvasEvent = this.onCanvasEvent;

        // # 07. 인터프리터 연결
        BlocklyManager.createInterpreter(this.canvasController, this.cbInterpreterRun, this.cbInterpreterStep);
      },
      runnerCanvasSetObject(MAP_SIZE, ARR_RESOURCE, ARR_OBJECT, ARR_SOLUTION, ARR_VARIABLE) {
        // 배경
        let bg;
        Blockly.mainWorkspace.bgList = [];
        Object.keys(ARR_RESOURCE)
          .forEach((key) => {
            const { type, basic } = ARR_RESOURCE[key];
            if (type === 'bgSet') {
              Blockly.mainWorkspace.bgList.push([key, key]);
              if (basic) bg = key;
            }
          });

        this.canvasController.setBG(bg);

        // 그리드 
        const { width, height } = document.getElementById(this.canvasID);
        this.canvasMakeGrid(
          this.canvasController, this.canvasGridId, width, height, MAP_SIZE
        );

        // 오브젝트
        ARR_OBJECT.forEach((e) => {
          this.canvasController.addObject(e);
        });

        // 솔루션
        ARR_SOLUTION.forEach((e) => {
          this.canvasController.addSolution(e);
        });

        this.canvasController.isVariable = true;
        ARR_VARIABLE.forEach((v) => { this.canvasController.setVariable(v); });

        // 종료 콜백
        this.canvasController.onCanvasEvent = (rtn) => {
          switch (rtn.clear) {
            case 0: {
              this.canvasStatusEnd = true;
              this.missionFail(rtn.reason);
              break;
            }
            case 1: {
              this.canvasStatusEnd = true;
              this.missionSuccess(rtn.point);
              break;
            }
            default:
          }
        };

        this.canvasController.BlocklyManager = BlocklyManager;
      },
      /**
       * [ Function :: canvasMakeGrid ]
       *
       * @DES :: 캔버스 그리드 만드는 함수
       * @IP1 :: controller {obj}
       * @IP2 :: gridID {str}
       * @IP3 :: cWidth {num}
       * @IP4 :: cHeight {num}
       * @IP5 :: horGrid {num}
       * @O.P ::
       * @S.E ::
       */
      canvasMakeGrid(controller, gridID, cWidth, cHeight, horGrid){
        if (Array.isArray(horGrid)) {
          if (horGrid.length === 4) {
            controller.addGrid({
              id: gridID,
              regX: (horGrid[2] - horGrid[0]) / 2,
              regY: (horGrid[3] - horGrid[1]) / 2,
              w: cWidth,
              h: cHeight,
              column: horGrid[2],
              row: horGrid[3]
            });
          } else {
            const ROW = parseInt(cHeight / ((cWidth / horGrid[0] * horGrid[1]) / horGrid[1]));
            controller.addGrid({
              id: gridID,
              regY: (ROW - horGrid[1]) / 2,
              w: cWidth,
              h: cHeight,
              column: horGrid[0],
              row: ROW
            });
          }
        } else {
          horGrid = parseInt(horGrid);
          const GRID_LENGTH = cWidth / horGrid;
          const GRID_X = horGrid;
          const GRID_Y = parseInt(cHeight / GRID_LENGTH);
          const CANVAS_HEIGHT = GRID_LENGTH * GRID_Y;

          controller.addGrid({
            id: gridID,
            x: 0,
            y: 0,
            w: cWidth,
            h: CANVAS_HEIGHT,
            row: GRID_Y,
            column: GRID_X
          });
        }
        controller.world[gridID].toggleGrid();
      },
      /**
       * [ Function :: onCanvasEvent ]
       *
       * @DES :: 캔버스 진행상태를 확인하는 함수
       * @IP1 :: rtn {json}
       * @O.P :: null
       * @S.E ::
       */
      onCanvasEvent(rtn) {
        // console.log(rtn);
        if(rtn.play) {
          // [#] 진행
          switch(rtn.clear) {
            case 0: // 실패
              this.canvasStatusEnd = true; // [#] Canvas가 종료됬다고 전달, "interpreter의 cbRun"에게
              this.missionFail();
              break;
            case 1: // 성공
              this.canvasStatusEnd = true; // [#] Canvas가 종료됬다고 전달, "interpreter의 cbRun"에게
              this.missionSuccess();
              break;
            case 2: // 계속 (기능없음)
              break;
          }
        }
        else {
          // [#] 종료
        }
      },
      /**
       * [ Function :: cbInterpreterRun ]
       *
       * @DES :: 인터프리터 '전체' 종료시 콜백
       * @IP1 :: null
       * @O.P :: null
       * @S.E :: "마지막 블록을 콜백보다 조금 일찍 실행됩니다."
       */
      cbInterpreterRun() {
        // /*[T]*/ console.log('cbInterpreterRun call');

        // [#] '성공 or 실패' 로써 다음 상태값을 해제할 수 있음, 인터프리터가 종료됬는데 'canvasStatusEnd'가 아직 'false'라는 것은 ???
        if(this.canvasStatusEnd === false) {
          this.missionFail(); // => "블록을 다 사용했지만 실패했다는 팝업처리"
        }
      },
      /**
       * [ Function :: cbInterpreterStep ]
       *
       * @DES :: 인터프리터 '스탭' 종료시 콜백
       * @IP1 :: null
       * @O.P :: null
       * @S.E :: 스탭마크취소 (스탭진행때만)
       */
      cbInterpreterStep() {
        if(BlocklyManager.interpreter.isRun === false) {
          this.canvasStatueStep = false;
        }
      },
      /**
       * [ Function :: restartCanvas ]
       *
       * @DES :: 캔버스를 재시작하는 함수 & 관련 상태값 처리가 같이 있음
       * @IP1 :: null
       * @O.P :: null
       * @S.E ::
       */
      restartCanvas() {
        // [#] 인터프리터 종료
        if (BlocklyManager.interpreter) BlocklyManager.interpreter.stop();
        // [#] 블록 하이라이트 제거
        if (Blockly.mainWorkspace) Blockly.mainWorkspace.highlightBlock();
        // [#] 스탭 마크 취소
        this.canvasStatueStep = false;
        // [#] 캔버스 종료상태 되돌리기
        this.gameRunnable = true;
        // [#] 캔버스 종료상태 되돌리기
        this.canvasStatusEnd = false;
        // [#] 재시작을 시키자!
        if (this.canvasController) this.canvasController.reloadQuestion();
        // [#] 시간초기화
        this.gameStartPoint = new Date();

        // # 사운드 초기화
        if (this.endPhase && this.needToToggle) {
          this.canvasController.toggleSound();
          this.endPhase = false;
          this.needToToggle = false;
        }
      },
      /**
       * [ Function :: missionFail ]
       *
       * @DES :: 미션에 실패했따 ! 둠칫
       * @IP1 :: null
       * @O.P :: null
       * @S.E ::
       */
      missionFail() {
        // [ 유저가 실패하기 직전에 다시하기를 눌렀을때 => 콜백은 왔는데, 인터프리터는 0(wait) 상태 ]
        if(
          this.isRunner
          || BlocklyManager.interpreter.status !== 0
          || this.canvasStatusEnd === false
        ) {
          this.endPhase = true;

          // [#] 종료시간 Pick!
          this.gameEndPoint = new Date();

          // [#] 인터프리터 중지
          if (!this.isRunner) BlocklyManager.interpreter.stop();

          // [#] 로그 저장하라고 위에 전달 !
          this.isCleared = 'N';
          this.$emit('call_save_log', () => {
            this.studyModalVue.showFailPopup();
          });

          // TODO
          // [#] 다시하기 콜백
          // studyModalVue.setConfirmEvent(this.restartCanvas);
          // studyModalVue.showFailPopup();
        }
      },
      /**
       * [ Function :: missionSuccess ]
       *
       * @DES :: 미션에 성공해따 ! 두둠칫
       * @IP1 :: null
       * @O.P :: null
       * @S.E ::
       */
      missionSuccess(point) {
        // [ 유저가 성공하기 직전에 다시하기를 눌렀을때 => 콜백은 왔는데, 인터프리터는 0(wait) 상태 ]
        if (
          this.isRunner
          || BlocklyManager.interpreter.status !== 0 /*wait*/
        ) {
          this.endPhase = true;

          // [#] 종료시간 Pick!
          this.gameEndPoint = new Date();

          // [#] 인터프리터 중지
          if (!this.isRunner) BlocklyManager.interpreter.stop();

          // [#] 로그 저장하라고 위에 전달 !
          this.isCleared = 'Y';
          this.$emit('call_save_log', () => {
            this.getClearTime((startTime, settingTime, runningTime) => {
              this.$emit('getBlockCount');
              this.studyModalVue.showSuccessPopup({
                clearTime: settingTime + runningTime,
                workCount: this.workCount,
                maxWorkCount: this.maxWorkCount,
                point
              });
            })
          });

        }
      },
      /**
       * [ Function :: initCanvas ]
       *
       * @DES :: 캔버스를 초기화 하자 !
       * @IP1 :: title {str}
       * @O.P :: null
       * @S.E :: s_web_stage.js 에서 호출 받음
       */
      initCanvas(title) {

        // [#] 시작시간초기화
        this.gameStartPoint = new Date();

        // [#] 미션제목연동
        this.selectedTitle = title;

        // [#] 캔버스생성
        this.createCanvas(this.setup_data);
      },
      /**
       *  @DESC   클리어 시간 획득 (From s_web_stage)
       *  @INPUT 	Callback
       *  @OUTPUT 시작시간, 블록 셋팅 시간, 러닝 타임.
       */
      getClearTime(cb) {
        const startTime = this.gameStartPoint;
        const settingTime = (this.gameRunningPoint - this.gameStartPoint) / 1000;
        const runningTime = ((this.gameEndPoint - this.gameRunningPoint) * this.gameSpeed) / 1000;
        cb(startTime, settingTime, runningTime);
      },
      libLoad() {
        let src;
        if (this.isRunner) {
          Canvas = require('../../assets/js/codmos/game/lcPlugIn/canvas/runner/dev/frame/R_Wrapper').default;
        } else {
          Canvas = require('../../assets/js/codmos/game/lcPlugIn/canvas/grid/dev/frame/G_Wrapper').default;
        }
        this.isLibLoad = true;
      }
    },
    mounted() {
      // [#] Canvas Resize
      const canvasWrapper = $('#ws-canvas-wrapper');
      const canvasInnerHeight = canvasWrapper.innerHeight();
      this.canvasHeight = canvasInnerHeight;
      this.canvasWidth = canvasInnerHeight * 0.85;

      // [#] Canvas restart emit
      this.transmit_call_canvas_init = this.restartCanvas;

      this.$emit('load');
    }
  }
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/components/stage/StagePartialCanvas.vue